var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"flex-column mt-10",attrs:{"no-gutters":"","align":"center","justify":"center"}},[_c('v-icon',{attrs:{"size":"100"}},[_vm._v("mdi-cart-outline")]),_c('div',{staticClass:"mt-5"},[_vm._v("Корзина пуста")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }